<template>
  <main class="main page-inside products-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="wrapper-top">
            <div class="title-container">
              <button class="back-page" @click="$parent.back">
                <img class="back-img" src="./../img/back-page.svg" />
              </button>
              <div class="title weight-600">{{ $t("Shop") }}</div>
            </div>
            <div class="tip">
              <div class="icon">
                <img src="./../img/gem.svg" class="icon-img" />
              </div>
              <div class="desc medium">
                {{ $t("Choose a category to see products") }}
              </div>
            </div>
          </div>
          <div class="categories">
            <transition name="fade">
              <div class="list" v-if="$parent.categories">
                <div
                  class="item"
                  v-for="(item, i) in $parent.categories"
                  :key="i"
                >
                  <div class="item-wrapper">
                    <button
                      :class="['desc small', { active: false }]"
                      @click="$emit('chooseCategoty', item)"
                    >
                      <b>{{ item.title }}</b>
                    </button>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div class="section categories-section">
        <div class="wrapper">
          <div class="title title-main weight-600">{{ $t("Categories") }}</div>
          <transition name="fade">
            <div class="list products" v-if="$parent.categories">
              <div
                class="item"
                v-for="(item, i) in $parent.categories"
                :key="i"
              >
                <div class="item-wrapper">
                  <div class="preview">
                    <img :src="imgDomain + item.image_url" class="img" />
                  </div>
                  <div class="desc small name">
                    <b>{{ item.title }}</b>
                  </div>
                  <button
                    class="button small bordered"
                    @click="$emit('chooseCategoty', item)"
                  >
                    {{ $t("VIEW") }}
                  </button>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Categories",
  components: {},
  data: function () {
    return {
      imgDomain: "",
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
};
</script>

<style scoped>
.categories-section .wrapper {
  position: relative;
  padding: 40px 0 100px;
  max-width: 1352px;
}

.categories-section .title-main {
  text-align: center;
}

.list.products .item .name {
  margin: 16px auto 24px;
  color: #011525;
}
</style>
